import { get, post } from "api";
import { CertifiedAuthorDetailResponse, CertifiedAuthorSubmitRequest } from "types/user/auth-writer";

// 修改用户个人中心信息
export const apiCreateAuthWriter = async (params: CertifiedAuthorSubmitRequest) =>
    await post<CertifiedAuthorSubmitRequest, never>(`/api/certified_author/submit`, params);

export const  apiGetAuthWriterDetail = async (type: number) => 
    await get<CertifiedAuthorSubmitRequest, CertifiedAuthorDetailResponse>(`/api/certified_author/detail/${type}`);
